exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media all and (min-width: 480px) {\n  .Create {\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n  }\n\n  .Create form {\n    margin: 20;\n    max-width: 320px;\n  }\n}\n", ""]);

